import React from 'react'
import { concatClientAndProjectName } from '../../../types/Engagement'

interface Props {
  projectName: string
  clientName: string
  teamName: string
  readOnly?: boolean
  handleTeamClick: (event: React.MouseEvent) => void
  handleEngagementClick: (event: React.MouseEvent) => void
}

const ProjectName = ({
  projectName,
  clientName,
  teamName,
  readOnly = false,
  handleTeamClick,
  handleEngagementClick,
}: Props) => {
  const subtitle = concatClientAndProjectName(clientName, projectName)

  return (
    <div>
      <div
        className={`tribe-org__engagement-title${
          !readOnly && teamName
            ? ' tribe-org__engagement-subtitle--clickable'
            : ''
        }`}
        style={{
          cursor: !readOnly && teamName ? 'pointer' : 'default',
        }}
        onClick={readOnly ? undefined : handleTeamClick}
      >
        {teamName}
      </div>
      <div
        className={`tribe-org__engagement-subtitle${
          !readOnly && projectName
            ? ' tribe-org__engagement-subtitle--clickable'
            : ''
        }`}
        style={{
          cursor: !readOnly && projectName ? 'pointer' : 'default',
        }}
        onClick={readOnly ? undefined : handleEngagementClick}
      >
        {subtitle}
      </div>
    </div>
  )
}

export default ProjectName
